<template>
  <div class="page page-reality-games">
      <r-cup-bar :cup-id="realityCupId" />
    <div class="k-tabs col-2 skin-2" id="rank-cup__tabs">
      <ul>
        <li class="k-tabs__item active r-eid-rgTabMy">
          <router-link tag="a" to="/reality/games">我的记录</router-link>
        </li>
        <li class="k-tabs__item r-eid-rgTabRank">
          <router-link tag="a" to="/reality/rank">排行榜</router-link>
          </li>
      </ul>
    </div>

    <k-table-actions v-if="allActions && allActions.length" :actions="allActions" skin="reality" />
    <txt-no-data v-else-if="allActions" message="暂无记录" />
    <txt-loading v-else />

  </div>
</template>

<script>
  import {
    mapGetters,
    mapActions
  } from 'vuex'
  export default {
    data() {
      return {}
    },
    computed: {
      ...mapGetters(['realityCupId', 'isAfter', 'finalRes']),
      ...mapGetters('reality', ['allActions'])
    },
    methods: {
      ...mapActions(['loadRealityCupId']),
      ...mapActions('reality', ['loadCup', 'loadCupPlayer', 'loadGames']),
    },
    async created() {
      let cupId = this.realityCupId
      if(!cupId) {
        await this.loadRealityCupId()
        cupId = this.realityCupId
      }
      await this.loadCup({cupId})
      await this.loadCupPlayer({cupId})
      await this.loadGames({
        cupId: this.realityCupId
      })
    }
  };

</script>
